export default {
    _representative: {
        id: 0,
        email: null,
        phone: null,
        name: '',
        surname: '',
        id_card: null,
        id_card_type: 'id',
        residence_street: null,
        residence_house_number: null,
        residence_flat_number: null,
        residence_postcode: null,
        residence_city: null,
        property_separation: null,
        marital_status: null,
        marital_status_other: ''
    },
    _guarantor: {
        client_id: '',
        id: '',
        name: '',
        surname: '',
        street: '',
        house_number: '',
        flat_number: '',
        postcode: '',
        city: '',
        id_card: '',
        id_card_type: 'id',
        pesel: '',
        nip: '',
        company_name: '',
        represented_by_proxy: '',
        proxy_name: '',
        proxy_surname: '',
        proxy_street: '',
        proxy_house_number: '',
        proxy_flat_number: '',
        proxy_postcode: '',
        proxy_city: '',
        proxy_id_card: '',
        proxy_id_card_type: 'id',
        proxy_pesel: '',
        proxy_phone: '',
        proxy_email: '',
        proxy_marital_status: null,
        proxy_marital_status_other: '',
        type: '',
        marital_status: null,
        marital_status_text: '',
        marital_status_other: '',
        guarantee_amount: 0,
        guarantee_date: '',
        regon: '',
        krs: ''
    },
    _guarantee: {
        id: '',
        client_id: '',
        type: '',
        number_land_mortgate_register: '',
        number_land: '',
        street: '',
        house_number: '',
        postcode: '',
        city: '',
        mortgage_amount: '0',
        is_burdens_on_property: '0',
        burdens_amount: '',
        files: []
    },
    _document: {
        id: '',
        client_id: '',
        type: '',
        file: null
    },
    _contact: {
        id: '',
        client_id: '',
        is_costs: '0',
        costs: '',
        type: '',
        files_to_delete: [],
        files: [
            { file: null }
        ]
    },
    _instructions: {
        id: '',
        recipient: '',
        amount: 0,
        account_number: '',
        transfer_title: '',
        transfer_date: '',
        conditions: [],
        schedule_id: '',
    },
    _condition: {
        id: null,
        name: '',
        status: 0,
        created_at: null,
        fulfilment_date: null,
        fulfilment_username: ''
    },
    _schedule: {
        id: '',
        documents: [],
        guarantors: [],
        company_id: null,
        payment_guarantees: [],
        comments: '',
        terminated_payment_date: '',
        case_is_explained_date: '',
        contract_date: '',
        contract_number: '',
        default_reminder_price: 0,
        contract_statement_amount: 0,
        contract_statement_date: '',
        contract_statement_doc: '',
        can_generate_invoice: false,
        client_id: null,   // id klienta
        installment_frequency: 2,      // częstotliwość rat
        installment_sum: 100,      // suma rat
        interest_sum: 0,      // suma odsetek
        interest_penalty_sum: 0,      // suma odsetek karnych
        loan_amount: 1000,   // kwota pożyczki
        installment_rate: 50,     // oprocentowanie raty
        interest_rate: 10,     // oprocentowanie odsetek
        installment_fee: 125,    // kwota raty
        number_of_installments: 12,     // liczba rat
        first_installment_date: '',     // data pierwszej raty
        loan_installment_sum: 0,      // suma kwoty pożyczki plus raty
        loan_final_sum: 0,      // kwota ostateczna
        is_archive: 0,
        draft: 1,
        case_is_explained: '0',
        invoices_docs_required: '0',
        invoices_docs_delivered_at: '',
        loan_purpose: '',
        discount_value: '',
        discount_type: 'none',
        discount_date: '',
        view_url: '',
        interest_view_url: '',
        provision_view_url: '',
        installments: [],
        provision_instructions_added: false,
        disposition_instructions_added: false,
        provision_instructions_amount: 0,
        disposition_instructions_amount: 0,
        company_extra_text_default: '',
        include_vat: 0,
        payment_allocation: 'capital_first',
        conditions: [],
    },
    _installment_frequency_periods: [
        { id: 5, name: '1 tygodzień' },
        { id: 1, name: '2 tygodnie' },
        { id: 2, name: '1 miesiąc' },
        { id: 3, name: '2 miesiące' },
        { id: 4, name: '3 miesiące' },
    ],
    _statuses: [
        { id: 1, name: 'Potencjalny klient', value: 'potential' },
        { id: 2, name: 'Klient w trakcie procesowania', value: 'processing' },
        { id: 3, name: 'Klient z umową', value: 'with_contract' },
    ],
    _types: [
        { id: 1, name: 'Działalność gospodarcza', value: 'buisness_activity' },
        { id: 2, name: 'Spółka', value: 'corporation' }
    ],
    _marital_statuses: [
        { id: 1, name: 'Żonaty / Zamężna', value: 1 },
        { id: 2, name: 'Kawaler / Panna', value: 0 },
        { id: 3, name: 'Inne', value: 2 }
    ],
    _property_separations: [
        { id: 1, name: 'Tak', value: 1 },
        { id: 2, name: 'Nie', value: 0 }
    ],
    _discount: {
        discount_active: false,
        discount_condition_met: false,
        discount_date: null,
        discount_for_provision: 0,
        discount_id: null,
        discount_name: '',
        discount_to_finish_credit: 0,
        discount_to_finish_credit_under_contract: 0,
        discount_value: 0
    }
}
